import {
  setSectionSelected,
  setCurrentSection,
  setNewCurrentNode,
} from '../../utilities';
import {
  PROTOCOL_SLIDE_TYPES,
  SLIDE_NODE,
  NOTEBOOK_SECTIONS,
  SLIDE_GROUP,
} from '@learningblocks/protocol-constants/lib/Utilities';

// set the simulation level. and load data for the particular level
export function setSimulationLevel(state, payload) {
  const protocolSection = createDesignSection(payload.levelData);
  return {
    ...state,
    showLevelModal: false,
    notebookCollapsed: false,
    levelData: payload.levelData,
    protocolSection,
    sections: setSectionSelected(setSections(payload.levelData), payload.levelData.COMPONENTS[0]),
    currentSection: setCurrentSection(payload.levelData, payload.levelData.COMPONENTS[0]),
    levelSelected: payload.levelId
  };
}

// set the notebook sections array.
function setSections(payload) {
  return payload.COMPONENTS.map((section, id) => ({
    number: id + 1,
    current: false,
    value: section,
    title: payload[section].title,
  }));
}

// update protocolSection data for opeartions
function createDesignSection(payload) {
  if (payload.COMPONENTS.includes(NOTEBOOK_SECTIONS.PROTOCOL)) {
    const designObject = payload[NOTEBOOK_SECTIONS.PROTOCOL];
    const currentSlide = getFirstSlideType(designObject);
    const allSlides = updateSlides(designObject.allSlides);
    return {
      ...designObject,
      currentSlide,
      allSlides,
    };
  } else {
    return {};
  }
}

// function to fetch type of firstitem in allSlides.
function getFirstSlideType(design) {
  const {allSlides} = design;
  if (allSlides.length) {
    return allSlides[0].type;
  } else {
    return '';
  }
}

function updateSlides(allSlides) {
  return allSlides.map((slide) => {
    switch (slide.type) {
      case PROTOCOL_SLIDE_TYPES.ONE:
        return updateSlideTypeOne(slide);
      case PROTOCOL_SLIDE_TYPES.TWO:
        return updateSlideTypeTwo(slide);
      case PROTOCOL_SLIDE_TYPES.THREE:
        return updateSlideTypeThree(slide);
      default:
        return slide;
    }
  });
}

function updateSlideTypeOne(slide) {
  const updateOption = (option) => {
    return {
      ...option,
      droppedId: null,
      wrongDrops: 0,
    };
  };
  return {
    ...slide,
    incorrects: 0,
    options: slide.options.map(updateOption),
  };
}

function updateSlideTypeTwo(slide) {
  const updateComponentAsCompleted = (component) => {
    return {...component, id: component.id, droppedId: component.id};
  };
  const updateComponentAsNotCompleted = (component) => {
    return {...component, id: component.id, droppedId: null};
  };
  const updateNodeOption = (option) => {
    return {...option, optionDisabled: false};
  };
  const updateSequenceNodeOption = (option) => {
    return {...option, selected: false};
  };
  const updateNode = (treeItem) => {
    if (
      treeItem.nodeType === SLIDE_NODE.START_NODE ||
      treeItem.nodeType === SLIDE_NODE.END_NODE
    ) {
      return {
        ...treeItem,
        nodeComponents: treeItem.nodeComponents.map(updateComponentAsCompleted),
        current: false,
      };
    } else {
      return {
        ...treeItem,
        nodeComponents: treeItem.nodeComponents.map(
          updateComponentAsNotCompleted
        ),
        nodeOptions: treeItem.nodeOptions.map(updateNodeOption),
        current: false,
      };
    }
  };
  const updateSequenceNodes = (treeItem) => {
    if (treeItem.nodeType === SLIDE_NODE.JOINT_PATH_SELECT) {
      return {
        ...treeItem,
        nodeOptions: treeItem.nodeOptions.map(updateSequenceNodeOption),
        current: false,
      };
    } else return updateNode(treeItem);
  };
  const updateNodeGroup = (nodeGroup) => {
    if (nodeGroup.groupType === SLIDE_GROUP.JOINT_GROUP_SEQUENCE) {
      return {
        ...nodeGroup,
        groupNodes: nodeGroup.groupNodes.map(updateSequenceNodes),
      };
    } else {
      return {...nodeGroup, groupNodes: nodeGroup.groupNodes.map(updateNode)};
    }
  };
  const updateSlideTree = (slideTree) => slideTree.map(updateNodeGroup);
  const slideTree = updateSlideTree(slide.slideTree);
  const updatedSlideTree = setNewCurrentNode(slideTree);
  return {
    ...slide,
    incorrects: 0,
    hintsUsed: 0,
    slideTree: updatedSlideTree,
  };
}

function updateSlideTypeThree(slideThree) {
  const updateNode = (node) => {
    return {
      ...node,
      droppedId: null,
      wrongAttempts: 0,
    };
  };
  const updateGroup = (group) => {
    return {
      ...group,
      groupNodes: group.groupNodes.map(updateNode),
    };
  };

  return {
    ...slideThree,
    incorrects: 0,
    hintsUsed: 0,
    slideTree: slideThree.slideTree.map(updateGroup),
  };
}
